<template>
  <AppForm label="配信デバイス">
    <v-layout row wrap>
      <v-flex xs4 style="max-width:160px;">
        <v-checkbox v-model="pc" :false-value="false" label="PC" />
      </v-flex>
      <v-flex xs4 style="max-width:160px;">
        <v-checkbox v-model="tablet" :false-value="false" label="タブレット" />
      </v-flex>
      <v-flex xs4 style="max-width:160px;">
        <v-checkbox
          v-model="phone"
          :disabled="advanced.requiredPhone"
          :false-value="false"
          label="スマートフォン"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <template v-if="errorMessages">
        <p v-for="message in errorMessages" class="red--text caption">
          {{ message }}
        </p>
      </template>
    </v-layout>
  </AppForm>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    advanced: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    pc: {
      get() {
        return this.value.includes('pc')
      },
      set(value) {
        if (value) {
          this.$emit('input', this.value.concat(['pc']))
        } else {
          this.remove('pc')
        }
      },
    },
    tablet: {
      get() {
        return this.value.includes('tablet')
      },
      set(value) {
        if (value) {
          this.$emit('input', this.value.concat(['tablet']))
        } else {
          this.remove('tablet')
        }
      },
    },
    phone: {
      get() {
        return this.value.includes('phone')
      },
      set(value) {
        if (value) {
          this.$emit('input', this.value.concat(['phone']))
        } else {
          this.remove('phone')
        }
      },
    },
    errorMessages() {
      const result = []
      if (this.advanced.isIncorrectDeviceCombinationWithWeb) {
        result.push(
          '配信面にWebブラウザを指定する場合は配信デバイスを１つ以上指定する必要があります',
        )
      }
      if (this.advanced.isIncorrectDeviceCombinationWithApp) {
        result.push(
          '配信面にアプリを指定する場合は配信デバイスにタブレットまたはスマートフォンのいずれか１つ以上を指定する必要があります',
        )
      }
      return result.length > 0 ? result : false
    },
  },
  methods: {
    remove(str) {
      const result = this.value.filter(v => v !== str)
      this.$emit('input', result)
    },
  },
}
</script>

<style></style>
